import type { U3400TileLogicalUnitCode } from '../U3400Service';
import {
  u340xBuildMetricConfig,
  u340xMetricKeysForCode,
  u340xSeriesStatusFromLength,
  type U340xKpiMetricKeys,
} from '../../u340xKpiShared/utils/u340xKpiLuConfig';

export type U3400CatalogueLabel = {
  code: string;
  labelFr: string;
  labelEn: string;
};

export type U3400MetricKeys = U340xKpiMetricKeys;

/** Titre tuile : labels catalogue API, sinon clé i18n de repli. */
export function u3400ResolveTileTitle(
  code: U3400TileLogicalUnitCode,
  catalogue: U3400CatalogueLabel[],
  isEn: boolean,
  fallback: (key: string) => string,
): string {
  const entry = catalogue.find((c) => c.code === code);
  if (entry) return isEn ? entry.labelEn : entry.labelFr;
  return fallback(`tiles.${code}`);
}

export function u3400MetricKeysForCode(code: U3400TileLogicalUnitCode) {
  return u340xMetricKeysForCode(code);
}

/** Construit la config dual-métrique pour U340xKpiTile. */
export function u3400BuildMetricConfig(
  code: U3400TileLogicalUnitCode,
  t: (key: string) => string,
) {
  return u340xBuildMetricConfig(code, t);
}

/** Statut série après fetch réussi (zéros = ready ; tableau vide = empty). */
export function u3400SeriesStatusFromLength(length: number): 'empty' | 'ready' {
  return u340xSeriesStatusFromLength(length);
}
